module.exports = __webpack_public_path__ + "static/media/preparando.2eca11a8.gif";